import { Lazy } from "./lazy";
import { IExtendedUserInformation } from "../types/interfaces";
import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { UrlHelper } from "./html/url-helper";

export class UserHelper {
	public static getInstance = Lazy.singleton(UserHelper);

	public extendedUserInformation: KnockoutObservable<IExtendedUserInformation> = ko.observable(null);

	public extendedUserInformationFormatted: KnockoutComputed<string> = ko.computed(() => {
		let curExtendedUserInformation = this.extendedUserInformation();
		if (!this.extendedUserInformation()) {
			return "";
		}

		return `(${curExtendedUserInformation.key ?? ""} [${curExtendedUserInformation.templateFullName ?? "Keine Vorlage"}])`;
	});

	public async loadExtendedUserInformationAsync(force: boolean = false) {
		if (this.extendedUserInformation() && !force) {
			return true;
		}

		if (!(UrlHelper.getUserId() > 0)) {
			return false;
		}

		let result: IExtendedUserInformation = await DialogResultVm.getDataWithWarningDialogRetryAsync({
			url: UrlHelper.getDataUrl("extended-user-information"),
			suppressDialog: true
		});

		if (result) {
			this.extendedUserInformation(result);
		}

		return true;
	}
}